/**
 * 판매자배송 공급관리 계산 — /api/marketplace/listProducts 줄(쿠팡에 적힌 재고 stockQuantity · 내가 적은 실제 재고 myStock · 30일 판매 units30) → 남은 일수.
 * 남은 일수 = floor(내가 적은 실제 재고 ÷ 30일 일평균) — 로켓그로스 공급관리 calcForecastStockDays 의 예측 자료 없을 때 식 그대로.
 * 빈 값은 0 이 아니라 까닭 글(«재고 안 적음» · «판매 안 모음» · «판매 없음») — 0일과 가른다.
 * 쿠팡에 적힌 판매자배송 재고가 큰 고정값이면 실재고가 아니다(셀러가 품절 막으려 999 등을 적어 둠) — 표지만 하고 계산·그대로 쓰기에서 뺀다.
 */

// 쿠팡 표시 재고 문턱 — 이 값 이상이면 «쿠팡 표시 재고(실재고 아님)». 실제 분포는 아직 못 잼(윙 응답 저장 전) · 정하면 여기 한 곳만 고친다
export const MARKETPLACE_FAKE_STOCK_MIN = 999

const DAYS = 30

function isNum(v) {
    return v !== null && v !== undefined && v !== '' && Number.isFinite(Number(v))
}

export function isFakeCoupangStock(stockQuantity) {
    return isNum(stockQuantity) && Number(stockQuantity) >= MARKETPLACE_FAKE_STOCK_MIN
}

/** 남은 일수 — { days: 숫자|null, why: '' | 까닭 } */
export function stockDays(p) {
    if (!isNum(p.myStock)) return { days: null, why: '재고 안 적음' }
    if (!isNum(p.units30)) return { days: null, why: '판매 안 모음' }
    const daily = Number(p.units30) / DAYS
    if (daily <= 0) return { days: null, why: '판매 없음' }
    return { days: Math.floor(Number(p.myStock) / daily), why: '' }
}

/** «쿠팡 재고 그대로 쓰기» 를 눌러도 되나 — 쿠팡 재고를 받았고 · 표시 재고가 아니고 · 이미 같은 값이 아닐 때 */
export function canCopyCoupangStock(p) {
    if (!isNum(p.stockQuantity) || isFakeCoupangStock(p.stockQuantity)) return false
    return !(isNum(p.myStock) && Number(p.myStock) === Number(p.stockQuantity))
}

export function buildScmRows(products) {
    return (products || []).map((p) => {
        const d = stockDays(p)
        return Object.assign({}, p, {
            dailyAvg: isNum(p.units30) ? Math.round((Number(p.units30) / DAYS) * 100) / 100 : null,
            days: d.days,
            why: d.why,
            fakeStock: isFakeCoupangStock(p.stockQuantity),
            canCopy: canCopyCoupangStock(p),
        })
    })
}
